import { render, staticRenderFns } from "./WButton.vue?vue&type=template&id=05a701b5&scoped=true"
import script from "./WButton.vue?vue&type=script&lang=js"
export * from "./WButton.vue?vue&type=script&lang=js"
import style0 from "./WButton.vue?vue&type=style&index=0&id=05a701b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a701b5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/skade-pwa/components/ui/atom/buttons/Button.vue').default})
